<template>
  <div class="module_title">
    <div v-if="data.titleImg" class="module_title_block backImg" @click="gotoIframe(data.moreUrl)">
      <img :src="data.titleImg"/>
    </div>
    <div v-else-if="data.moduleName" class="module_title_block space">
      <p class="module_title_name add_dot">{{ data.moduleName }}</p>
      <div
          v-if="data.moreUrl"
          class="module_title_more"
          @click="gotoIframe(data.moreUrl)"
      >
        <span>更多</span
        ><i
          v-if="data.moreUrl"
          class="module_title_icon"
          @click="gotoIframe(data.moreUrl)"
      ></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {};
  },
  methods: {
    gotoIframe(link) {
      if (!link) {
        return;
      }
      if (
        link.indexOf('/topic') !== -1 ||
          link.indexOf('h5.da.mgtv.com') !== -1
      ) {
        window.location.href = link;
      } else {
        this.$router.push({
          path: 'iframe',
          query: { link: encodeURIComponent(link) },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.module_title {
  font-family: PingFang SC;

  &_block {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &_name {
    font-size: 36px;
    font-weight: 500;
    color: rgba(35, 35, 35, 1);
    font-weight: bold;
  }

  .backImg {
    height: 90px;
  }

  .space {
    margin: 0px 30px 0px 30px;
  }

  &_name {
    width: 400px;
  }

  &_more {
    display: flex;
    align-items: center;
    position: absolute;
    font-size: 26px;
    color: rgba(56, 56, 56, 1);
    right: 0px;
    font-weight: 400;

    span {
      margin-right: 10px
    }
  }

  &_icon {
    width: 24px;
    height: 24px;
    background: url("~assets/img/icon/showMore.png") no-repeat;
    background-size: contain;

  }
}
</style>
